<template>
  <div class="page-main">
    <div class="box">
      <div class="box-top">
        <div class="title">常用功能</div>
        <div class="group">
          <div class="list" v-for="(itemSt, indexSt) in gong_neng_list" :key="indexSt">
            <div
              :class="{
                item: true,
                disabled: itemNd.disabled
              }"
              v-for="(itemNd, indexNd) in itemSt"
              :key="indexNd"
              @click="itemClickTop(itemNd)"
            >
              <span class="icon iconfont" :class="itemNd.icon" />
              <span class="name">{{ itemNd.key }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-bottom">
        <div class="title">常用业务处理表</div>
        <div class="group">
          <div class="list" v-for="(itemSt, indexSt) in ye_wu_list" :key="indexSt">
            <div
              v-for="(itemNd, indexNd) in itemSt"
              v-show="itemIsShow(itemNd)"
              :key="indexNd"
              :title="itemNd.key"
              :class="{
                item: true,
                disabled: itemNd.disabled
              }"
              @click="itemClickBottom(itemNd)"
            >
              <el-badge :value="itemNd.count" :max="99" :type="itemNd.isRed ? 'danger' : 'info'">
                <div class="name ellipsis">
                  {{ itemNd.key }}
                </div>
              </el-badge>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from './common/constant'
export default {
  data() {
    return {
      gong_neng_list: constant.gong_neng_list,
      ye_wu_list: constant.ye_wu_list,
      admin_list: ['客户成本列表', '客户分析表']
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  mounted() {
    this.getCounts()
  },
  methods: {
    getCounts() {
      this.$api({
        method: 'post',
        url: '/admin/customers/getStatusCount'
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let result = this.$util.deepCopy(res.data.data)
            this.ye_wu_list.forEach((itemSt, indexSt) => {
              itemSt.forEach((itemNd) => {
                if (indexSt === 0) {
                  if (itemNd.key === '客户列表') itemNd.count = result.ke_hu.total_ke_hu_count
                  if (itemNd.key === '待接待客户') itemNd.count = result.ke_hu.dai_jie_dai_count
                  if (itemNd.key === '已成交客户') itemNd.count = result.ke_hu.yi_cheng_jiao_count
                  if (itemNd.key === '未成交客户') itemNd.count = result.ke_hu.wei_cheng_jiao_count
                  if (itemNd.key === '10天没跟进客户')
                    itemNd.count = result.ke_hu.shi_tian_wei_gen_jin_count
                  if (itemNd.key === '20天没跟进客户')
                    itemNd.count = result.ke_hu.er_shi_tian_wei_gen_jin_count
                  if (itemNd.key === '30天没跟进客户')
                    itemNd.count = result.ke_hu.san_shi_tian_wei_gen_jin_count
                }
                if (indexSt === 1) {
                  itemNd.count = result.he_suan_dan.total_he_suan_dan_count
                  if (itemNd.key === '暂存') itemNd.count = result.he_suan_dan.zan_cun_count
                  if (itemNd.key === '已驳回') itemNd.count = result.he_suan_dan.yi_bo_hui_count
                }
                if (indexSt === 2) {
                  itemNd.count = result.ding_dan.total_ding_dan_count
                  if (itemNd.key === '待审核') itemNd.count = result.ding_dan.dai_shen_he_count
                  if (itemNd.key === '进行中') itemNd.count = result.ding_dan.jin_xing_zhong_count
                  if (itemNd.key === '已完结') itemNd.count = result.ding_dan.yi_wan_jie_count
                  if (itemNd.key === '已作废') itemNd.count = result.ding_dan.yi_zuo_fei_count
                }
                if (indexSt === 3) {
                  itemNd.count = result.gong_cheng_xie_tong.total_gong_cheng_xie_tong_count
                  if (itemNd.key === '待处理')
                    itemNd.count = result.gong_cheng_xie_tong.dai_chu_li_count
                  if (itemNd.key === '待处理')
                    itemNd.count = result.gong_cheng_xie_tong.dai_chu_li_count
                  if (itemNd.key === '处理中')
                    itemNd.count = result.gong_cheng_xie_tong.chu_li_zhong_count
                  if (itemNd.key === '已完成')
                    itemNd.count = result.gong_cheng_xie_tong.yi_wan_cheng_count
                  if (itemNd.key === '已取消')
                    itemNd.count = result.gong_cheng_xie_tong.yi_qu_xiao_count
                }
              })
            })
          }
        })
        .catch(() => {})
    },
    itemClickTop(val) {
      if (val.disabled) {
        this.moduleLoading()
      } else {
        window.open(val.url, '_blank')
      }
    },
    itemClickBottom(val) {
      if (val.disabled) {
        this.moduleLoading()
      } else {
        window.open(val.url, '_blank')
      }
    },
    itemIsShow(val) {
      let result = true
      let isNormalItem = this.admin_list.every((item) => item !== val.key)
      if (!isNormalItem && !this.isAdmin) result = false
      return result
    },
    moduleLoading() {
      this.$message.info('功能开发中...')
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  height: 100%;
  display: flex;
  .box {
    flex: 1;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 2px solid #ddd;
    }
    .box-top {
      flex: 1;
      display: flex;
      flex-direction: column;
      .title {
        color: @colorGreen;
        border-color: @colorGreen;
      }
      .group {
        .list {
          display: flex;
          & ~ .list {
            margin-top: 10px;
          }
          .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 80px;
            color: @colorGreen;
            background: @colorGreen20;
            border: 2px solid @colorGreen20;
            border-radius: 6px;
            cursor: pointer;
            overflow: hidden;
            & ~ .item {
              margin-left: 10px;
            }
            &:hover {
              color: @colorWhite;
              background: @colorGreen;
              border-color: @colorGreen;
            }
            &.disabled {
              cursor: not-allowed;
              color: @colorGrayDeep;
              background: @colorGrayF;
              border-color: @colorGrayE;
            }
            .icon {
              font-size: 24px;
            }
            .name {
              margin-top: 5px;
              font-weight: bold;
            }
          }
        }
      }
    }
    .box-bottom {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      .title {
        color: @colorBlue;
        border-color: @colorBlue;
      }
      .group {
        display: flex;
        .list {
          & ~ .list {
            margin-left: 10px;
          }
          .item {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 28px;
            padding: 0 5px;
            color: @colorBlue;
            background: @colorBlue20;
            border: 1px solid @colorBlue20;
            border-radius: 3px;
            cursor: pointer;
            & ~ .item {
              margin-top: 10px;
            }
            &:hover {
              color: @colorWhite;
              background: @colorBlue;
              border-color: @colorBlue;
            }
            &.disabled {
              cursor: not-allowed;
              color: @colorGrayDeep;
              background: @colorGrayF;
              border-color: @colorGrayE;
            }
            .icon {
              font-size: 16px;
            }
            .name {
              text-align: center;
              width: 72px;
            }
          }
        }
      }
    }
  }
  /deep/ .el-badge {
    position: initial;
    .el-badge__content {
      height: 14px;
      line-height: 14px;
      padding: 0 4px;
    }
    .el-badge__content.is-fixed {
      top: -8px;
      right: -8px;
      transform: none;
    }
    .el-badge__content--info {
      color: #666;
      background: #ddd;
    }
  }
}
</style>
